import { render, staticRenderFns } from "./EditExif.vue?vue&type=template&id=04560c2a&scoped=true"
import script from "./EditExif.vue?vue&type=script&lang=ts"
export * from "./EditExif.vue?vue&type=script&lang=ts"
import style0 from "./EditExif.vue?vue&type=style&index=0&id=04560c2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04560c2a",
  null
  
)

export default component.exports